module.exports = __webpack_public_path__ + "img/ozon.e0c3f6a4.png";